<template>
  <div class="box-shadow">
  <form>
    <div class="col-sm-12">
      <h4 class="heading">Basic Details</h4>
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Client Type</label>
          <select name="type" class="form-control" v-model="formInput.type">
            <option selected>Natural Persons</option>
            <option>Corporate</option>
            <option>FX</option>
          </select>
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.client_group_name')}">
          <label>Client Group</label><span class="message">{{ validation.firstError('formInput.client_group_name') }}</span>
          <vue-bootstrap-typeahead
            ref="client_group_name"
            :data="clinetGroups"
            v-model="formInput.client_group_name"
            :serializer="clientGroupFormattedDisplay"
            placeholder="Search Client Group"
            @hit="setClientGroupInfo"
          />
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.agent_account')}">
          <label>Agent Account</label><span class="message">{{ validation.firstError('formInput.agent_account') }}</span>
          <vue-bootstrap-typeahead
            ref="agent_account"
            :data="agentAccounts"
            v-model="formInput.agent_account"
            :serializer="agentAccountFormattedDisplay"
            placeholder="Search Agent Account"
            @hit="setAgentAccountInfo"
          />
        </div> 
      </div>
      <div v-if="['Natural Persons','FX'].indexOf(formInput.type)>=0" class="row">
        <div class="col-sm-3 form-group">
          <label>Title</label>
          <select name="title" class="form-control" v-model="formInput.title">
            <option value="">Select Your Title</option>
            <option>Mr.</option>
            <option>Ms.</option>
            <option>Mrs.</option>
            <option>Dr.</option>
          </select>
        </div>    
        <div class="col-sm-3 form-group" :class="{error: validation.hasError('formInput.firstname')}">
          <label>First Name</label><span class="message">{{ validation.firstError('formInput.firstname') }}</span>
          <input type="text" placeholder="Enter First Name Here.." class="form-control" v-model="formInput.firstname">
        </div>
        <div class="col-sm-3 form-group" :class="{error: validation.hasError('formInput.lastname')}">
          <label>Last Name</label><span class="message">{{ validation.firstError('formInput.lastname') }}</span>
          <input type="text" placeholder="Enter Last Name Here.." class="form-control" v-model="formInput.lastname">
        </div>  
        <div class="col-sm-3 form-group" :class="{error: validation.hasError('formInput.initials')}">
          <label>Client Initial</label><span class="message">{{ validation.firstError('formInput.initials') }}</span>
          <input type="text" placeholder="Enter Client Initial Here.." class="form-control" v-model="formInput.initials">
        </div>  
      </div>
      <div class="row" v-else>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.firstname')}">
          <label>Name</label><span class="message">{{ validation.firstError('formInput.firstname') }}</span>
          <input type="text" placeholder="Enter Corporate Name Here.." class="form-control" v-model="formInput.firstname">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.initials')}">
          <label>Client Initial</label><span class="message">{{ validation.firstError('formInput.initials') }}</span>
          <input type="text" placeholder="Enter Client Initial Here.." class="form-control" v-model="formInput.initials">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.account_number')}">
          <label>Account Number</label><span class="message">{{ validation.firstError('formInput.account_number') }}</span>
          <vue-bootstrap-typeahead
            ref="account_number"
            :data="customers"
            v-model="formInput.account_number"
            :serializer="customerFormattedDisplay"
            placeholder="Search Account No."
            @hit="setCustomerInfo"
          />
          <!--<label>Account No.</label><span class="message">{{ validation.firstError('formInput.account_number') }}</span>
          <input type="text" placeholder="Enter Account No. Here.." class="form-control" v-model="formInput.account_number">-->
        </div>
        <div class="col-sm-4 form-group">
          <label>Client Categorization</label>
          <select class="form-control" v-model="formInput.client_category_id">
            <option value="">Select Categorization</option>
            <option v-for="cat in client_categories" :key="cat.id" :value="cat.id">{{cat.name}}</option>
          </select>
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.phone_no')}">
          <label>Phone Number (Mobile)</label><span class="message">{{ validation.firstError('formInput.phone_no') }}</span>
          <input type="text" placeholder="Enter Phone Number Here.." class="form-control" v-model="formInput.phone_no">
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.email')}">
          <label>Email Address</label><span class="message">{{ validation.firstError('formInput.email') }}</span>
          <input type="email" placeholder="Enter Email Address Here.." class="form-control" v-model="formInput.email">
        </div>           
        <!-- <div class="form-group" v-for="(email,k) in additional_emails" :key="k"> -->
        <div class="col-sm-4 form-group">
          <label>Additional Email Address (use ',' to split)</label>
          <input type="text" class="form-control" v-model="formInput.other_details.additional_email">
          <!-- <span>
            <i class="fas fa-minus-circle" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)">Remove</i>
            <i class="fas fa-plus-circle" @click="add(k)" v-show="k == inputs.length-1">Add fields</i>
          </span> -->
        </div>    
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.dob')}" v-if="['Natural Persons','FX'].indexOf(formInput.type)>=0">
          <label>Date Of Birth (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.dob') }}</span><br>
          <date-picker input-class="form-control" ref="dob" type="date" v-model="formInput.dob" value-type="format" format='DD-MM-YYYY'></date-picker>
          <!--<input type="text" placeholder="Enter Date Of Birth Here.." class="form-control" v-model="formInput.dob">-->
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.dob')}" v-else>
          <label>Registration / Incorporation Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.dob') }}</span><br>
          <date-picker input-class="form-control" ref="dob" type="date" v-model="formInput.dob" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.address')}">
          <label>Address</label><span class="message">{{ validation.firstError('formInput.address') }}</span>
          <input type="text" placeholder="Enter Address Here.." class="form-control" v-model="formInput.address">
          <!-- <textarea placeholder="Enter Address Here.." rows="3" class="form-control"></textarea> -->
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.city')}">
          <label>City</label><span class="message">{{ validation.firstError('formInput.city') }}</span>
          <input type="text" placeholder="Enter City Name Here.." class="form-control" v-model="formInput.city">
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.state')}">
          <label>State</label><span class="message">{{ validation.firstError('formInput.state') }}</span>
          <input type="text" placeholder="Enter State Name Here.." class="form-control" v-model="formInput.state">
        </div> 
        <div class="col-sm-4 form-group">
          <label>Country(ies) of tax residency</label>
          <input type="text" placeholder="Enter Country(ies) of tax residency Here.." class="form-control" v-model="formInput.country">
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.zip')}">
          <label>Zip</label><span class="message">{{ validation.firstError('formInput.zip') }}</span>
          <input type="text" placeholder="Enter Zip Code Here.." class="form-control" v-model="formInput.zip">
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.ni_number')}">
          <label>NI/LEI Number</label><span class="message">{{ validation.firstError('formInput.ni_number') }}</span>
          <input type="text" placeholder="Enter NI/LEI Number Here.." class="form-control" v-model="formInput.ni_number">
        </div>  
        <div class="col-sm-4 form-group">
          <label>Number of years at address</label>
          <select name="no_of_years_in_address" class="form-control" v-model="formInput.no_of_years_in_address">
            <option value="">Select No. Of Years</option>
            <option value="3-">Less Than 3 Years</option>
            <option value="3+">More Than 3 Years</option>
          </select>
        </div>     
        <div class="col-sm-4 form-group">
            <label>TTCA Agreement</label>
            <select name="TTCA_agreement" class="form-control" v-model="formInput.other_details.TTCA_agreement">
              <option value="">Select TTCA Agreement</option>
              <option>YES</option>
              <option>NO</option>
              <option>N/A</option>
            </select>
          </div>    
      </div>
      <div class="row" v-if="formInput.no_of_years_in_address=='3-'">
        <div class="col-sm-3 form-group">
          <label>Prev. Address</label>
          <input type="text" placeholder="Enter State Name Here.." class="form-control">
          <!-- <textarea placeholder="Enter Address Here.." rows="3" class="form-control"></textarea> -->
        </div>  
        <div class="col-sm-3 form-group">
          <label>Prev. City</label>
          <input type="text" placeholder="Enter City Name Here.." class="form-control">
        </div>  
        <div class="col-sm-3 form-group">
          <label>Prev. State</label>
          <input type="text" placeholder="Enter State Name Here.." class="form-control">
        </div>  
        <div class="col-sm-3 form-group">
          <label>Prev. Country</label>
          <input type="text" placeholder="Enter Country(ies) of tax residency Here.." class="form-control">
        </div> 
      </div>
      <div class="form-group">
        <a href="#" @click="setShowDetailedForm">add {{lessOrMore}} details</a>
      </div>
      <div v-if="showDetailedForm">
        <h4 class="heading">Other Details</h4>
        <div class="row">
          <div class="col-sm-4 form-group">
            <label>Education</label>
            <select name="education" class="form-control" v-model="formInput.other_details.education">
              <option value="">Select Education</option>
              <option>GCSEs</option>
              <option>Bachelors</option>
              <option>PhD</option>
              <option>A-Levels</option>
              <option>Masters</option>
              <option>Other</option>
            </select>
          </div>    
          <div class="col-sm-4 form-group">
            <label>Employment Status</label>
            <select name="employment_status" class="form-control" v-model="formInput.other_details.employment_status">
              <option value="">Select Employment Status</option>
              <option>Employed</option>
              <option>Unemployed</option>
              <option>Self Employed</option>
              <option>Retired</option>
              <option>Student</option>
            </select>
          </div>  
          <div class="col-sm-4 form-group">
            <label>Occupation</label>
            <input type="text" placeholder="Enter Occupation Here.." class="form-control" v-model="formInput.other_details.occupation">
          </div>
          <div class="col-sm-4 form-group">
            <label>Employment Sector</label>
            <input type="text" placeholder="Enter Employment Sector Here.." class="form-control" v-model="formInput.other_details.employment_sector">
          </div>
          <div class="col-sm-4 form-group">
            <label>Annual income</label>
            <input type="text" placeholder="Enter Annual income Here.." class="form-control" v-model="formInput.other_details.annual_income">
          </div>
          <div class="col-sm-4 form-group">
            <label>Size of investment portfolio</label>
            <input type="text" placeholder="Enter Size of investment portfolio Here.." class="form-control" v-model="formInput.other_details.size_of_investment">
          </div>
        </div> 

        <div>
          <h4 class="heading">Investment Account</h4>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>How do you intend to fund your account?</label>
              <select class="form-control" name="how_to_fund_account" v-model="formInput.other_details.funding_method">
                <option value="">Select Funding Method</option>
                <option>Savings</option>
                <option>Dividends</option>
                <option>Gift</option>
                <option>Investment profits</option>
                <option>Remuneration from employer</option>
                <option>Sale of property or other assets</option>
                <option>Beneficiary of Trust</option>
                <option value="normal_business_operation">Normal business operations (if a legal entity)</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="col-sm-4 form-group">
              <label>What type of securities do you intend to trade?</label>
              <select class="form-control" name="type_of_securities_intend_to_trade" v-model="formInput.other_details.security_type">
                <option value="">Select Security Type</option>
                <option>Equities</option>
                <option>Equity Swaps</option>
              </select>
            </div>
            <div class="col-sm-4 form-group">
              <label>How much do you intend to invest per year?</label>
              <input type="text" placeholder="Enter Where did you hear.." class="form-control" v-model="formInput.other_details.how_much_you_invest_per_year">
            </div>
            <div class="col-sm-4 form-group">
              <label>Where did you hear about our service?</label>
              <input type="text" placeholder="Enter Where did you hear.." class="form-control" v-model="formInput.other_details.how_do_you_know_about_us">
            </div>
            <div class="col-sm-4 form-group">
              <label>Expected initial deposit into investment account</label>
              <input type="text" placeholder="Enter Expected initial deposit.." class="form-control" v-model="formInput.other_details.initial_deposit_amount">
            </div>
          </div>
        </div>

        <div>
          <h4 class="heading">Investment Experience</h4>
          <div class="form-group">
            <label>In the last 12 months, how many trades have you executed in the following instruments?</label>
          </div>
          <div class="" style="display:flex">
            <div class="col-sm-4 form-group">
              <label>Shares</label>
              <select name="how_many_trades_in_shares" class="form-control" v-model="formInput.other_details.how_many_trades_in_shares">
                <option value="">Select Shares</option>
                <option>0</option>
                <option>1-10</option>
                <option>11-20</option>
                <option>20+</option>
              </select>
            </div>  
            <div class="col-sm-4 form-group">
              <label>FX</label>
              <select name="how_many_trades_in_fx" class="form-control" v-model="formInput.other_details.how_many_trades_in_fx">
                <option value="">Select FX</option>
                <option>0</option>
                <option>1-10</option>
                <option>11-20</option>
                <option>20+</option>
              </select>
            </div>  
            <div class="col-sm-4 form-group">
              <label>Equity derivatives</label>
              <select name="how_many_trades_in_equity" class="form-control" v-model="formInput.other_details.how_many_trades_in_equity_derivatives">
                <option value="">Select Equity derivatives</option>
                <option>0</option>
                <option>1-10</option>
                <option>11-20</option>
                <option>20+</option>
              </select>
            </div>  
          </div>

          <div class="">
            <h4 class="heading">IRESS Source Details</h4>
            <div class="row">
              <div class="col-sm-4 form-group">
                <label>Limit Group</label>
                <input type="text" placeholder="Enter Limit Group.." class="form-control" v-model="formInput.other_details.limit_group">
              </div>
              <div class="col-sm-4 form-group">
                <label>CFD Provider Name</label>
                <input type="text" placeholder="Enter CFD Provider Name.." class="form-control" v-model="formInput.other_details.cfd_provider_name">
              </div>
              <div class="col-sm-4 form-group">
                <label>Account Groups</label>
                <input type="text" placeholder="Enter Account Groups.." class="form-control" v-model="formInput.other_details.account_group">
              </div>
              <div class="col-sm-4 form-group">
                <label>Organization</label>
                <input type="text" placeholder="Enter Organization.." class="form-control" v-model="formInput.other_details.organization">
              </div>
              <div class="col-sm-4 form-group">
                <label>Supervisor Set</label>
                <input type="text" placeholder="Enter Supervisor Set.." class="form-control" v-model="formInput.other_details.supervisor_set">
              </div>
              <div class="col-sm-4 form-group">
                <label>Operator Set</label>
                <input type="text" placeholder="Enter Operator Set.." class="form-control" v-model="formInput.other_details.operator_set">
              </div>
              <div class="col-sm-4 form-group">
                <label>Discretionary Set</label>
                <input type="text" placeholder="Enter Discretionary Set.." class="form-control" v-model="formInput.other_details.discretionary_set">
              </div>
              <div class="col-sm-4 form-group">
                <label>Account Active</label>
                <input type="text" placeholder="Enter Account Active.." class="form-control" v-model="formInput.other_details.account_active">
              </div>
              <div class="col-sm-4 form-group">
                <label>User Active</label>
                <select name="user_active" class="form-control" v-model="formInput.other_details.user_active">
                  <option value="">Select User Active</option>
                  <option>Y</option>
                  <option>N</option>
                </select>
              </div>  
              <div class="col-sm-4 form-group">
                <label>Exchange Group</label>
                <input type="text" placeholder="Enter.." class="form-control" v-model="formInput.other_details.exchange_group">
              </div>  
              <div class="col-sm-4 form-group">
                <label>Destination Group</label>
                <input type="text" placeholder="Enter.." class="form-control" v-model="formInput.other_details.destination_group">
              </div>  
              <div class="col-sm-4 form-group">
                <label>ReadOnly</label>
                <select name="read_only" class="form-control" v-model="formInput.other_details.read_only">
                  <option value="">Select ReadOnly</option>
                  <option>Y</option>
                  <option>N</option>
                </select>
              </div> 
              <div class="col-sm-4 form-group">
                <label>User Can Impersonate</label>
                <input type="number" placeholder="Enter.." class="form-control" v-model="formInput.other_details.user_can_impersonate">
              </div>
              <div class="col-sm-4 form-group">
                <label>User Can Be Impersonated</label>
                <input type="number" placeholder="Enter.." class="form-control" v-model="formInput.other_details.user_can_be_impersonated">
              </div>
              <div class="col-sm-4 form-group">
                <label>Access Type</label>
                <input type="number" placeholder="Enter.." class="form-control" v-model="formInput.other_details.access_type">
              </div> 
              <div class="col-sm-4 form-group">
                <label>User Code</label>
                <input type="text" placeholder="Enter.." class="form-control" v-model="formInput.other_details.user_code">
              </div> 
              <!-- <div class="col-sm-4 form-group">
                <label>Upload Source</label>
                <input type="text" placeholder="Enter.." class="form-control" v-model="formInput.other_details.upload_source">
              </div>  -->
            </div>
          </div>

          <div class="form-group">
            <div class="form-group">
              <label>Have you worked in a financial services institution in the last 12 months that will have required knowledge of the instruments which you are looking to trade?</label>
            </div>
            <div class="col-sm-12">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_req_knowledge_in_trade" id="have_req_knowledge_in_trade_yes" value="yes" v-model="formInput.other_details.have_req_knowledge_in_trade">
                <label class="form-check-label" for="have_req_knowledge_in_trade_yes">YES</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_req_knowledge_in_trade" id="have_req_knowledge_in_trade_no" value="no" v-model="formInput.other_details.have_req_knowledge_in_trade">
                <label class="form-check-label" for="have_req_knowledge_in_trade_no">NO</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-group">
              <label>Have you received education or training on the instruments which your are looking to trade?</label>
            </div>
            <div class="col-sm-12">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_trained_for_trade" id="have_trained_for_trade_yes" value="yes" v-model="formInput.other_details.have_trained_for_trade">
                <label class="form-check-label" for="have_trained_for_trade_yes">YES</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_trained_for_trade" id="have_trained_for_trade_no" value="no" v-model="formInput.other_details.have_trained_for_trade">
                <label class="form-check-label" for="have_trained_for_trade_no">NO</label>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <h4 class="heading">Bank Account Details</h4>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>Account Name</label>
              <input type="text" placeholder="Enter Account Name.." class="form-control" v-model="formInput.other_details.bank_account_name">
            </div>
            <div class="col-sm-4 form-group">
              <label>Account Number</label>
              <input type="text" placeholder="Enter Account Number.." class="form-control" v-model="formInput.other_details.bank_account_number">
            </div>
            <div class="col-sm-4 form-group">
              <label>Sort Code</label>
              <input type="text" placeholder="Enter Sort Code.." class="form-control" v-model="formInput.other_details.bank_account_sort_code">
            </div>
          </div>
        </div>

        <div class="form-group">
          <h4 class="heading">Declaration</h4>
          <div class="form-group form-check">
            <input name="read_terms_and_condtn" class="form-check-input" type="checkbox" value="" id="read_terms_and_condtn" v-model="formInput.other_details.read_terms_and_condtn">
            <label class="form-check-label" for="read_terms_and_condtn">
              I acknowledge that I have read {{ config('app.company.name') }} Terms and Conditions.
            </label>
          </div>
          <div class="form-group form-check">
            <input name="risk_warning_notice" class="form-check-input" type="checkbox" value="" id="risk_warning_notice" v-model="formInput.other_details.risk_warning_notice">
            <label class="form-check-label" for="risk_warning_notice">
              I acknowledge that I have read the risk warning notices and understand the risks of investing
            </label>
          </div>
          <div class="form-group form-check">
            <input name="read_privacy_policy" class="form-check-input" type="checkbox" value="" id="read_privacy_policy" v-model="formInput.other_details.read_privacy_policy">
            <label class="form-check-label" for="read_privacy_policy">
              I acknowledge that my personal information will be held {{ config('app.company.name') }} and that I have read the privacy notice here.
            </label>
          </div>
          <div class="form-group form-check">
            <input name="wont_provide_advice_in_trading" class="form-check-input" type="checkbox" value="" id="wont_provide_advice_in_trading" v-model="formInput.other_details.wont_provide_advice_in_trading">
            <label class="form-check-label" for="wont_provide_advice_in_trading">
              I acknowledge that {{ config('app.company.name') }} is not providing me with advice in relation to the trading service
            </label>
          </div>
        </div>
      </div>
      <input type="hidden" v-model="formInput.id"/>
      <div class="" style="display:flow-root">
        <button type="button" v-on:click="addCustomer" class="btn btn-lg btn-info pull-right">Submit</button> 
      </div>         
    </div>
  </form>
  </div>
</template>

<script>
import axios from 'axios';
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddCustomerForm',
  props:['rows', 'forceRerender'],
  components: { DatePicker,VueBootstrapTypeahead },
  mixins: [common,SimpleVueValidator.mixin],
  data(){
    return {
      showDetailedForm: false,
      lessOrMore: "more",
      customers: [],
      client_categories: {},
      clinetGroups: {},
      agentAccounts: {},
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date ? moment(date).format('DD-MM-YYYY') : ''
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, 'DD-MM-YYYY').toDate() : null
        }
      },
      formInput:{
        'id' : '',
        'action': 'create',
        'client_group_name': '',
        'client_group_id': '',
        'agent_account': '',
        'title' : '',
        'firstname' : '',
        'lastname' : '',
        'initials' : '',
        'account_number' : '',
        'client_category_id': '',
        'type': 'Natural Persons',
        'dob' : '',
        'phone_no' : '',
        'alt_phone_no' : '',
        'email' : '',
        'ni_number' : '',
        'address' : '',
        'city' : '',
        'state' : '',
        'country' : '',
        'zip' : '',
        'no_of_years_in_address' : '',
        'status': 1,
        'other_details' : {
          'additional_email': '',
          'education' : '',
          'employee_status' : '',
          'occupation' : '',
          'employment_sector' : '',
          'annual_income' : '',
          'size_of_investment' : '',
          'funding_method' : '',
          'security_type' : '',
          'how_much_you_invest_per_year' : '',
          'how_do_you_know_about_us' : '',
          'initial_deposit_amount' : '',
          'how_many_trades_in_shares' : '',
          'how_many_trades_in_fx' : '',
          'how_many_trades_in_equity_derivatives' : '',
          'have_req_knowledge_in_trade' : '',
          'have_trained_for_trade' : '',
          'bank_account_name' : '',
          'bank_account_number' : '',
          'bank_account_sort_code' : '',
          'read_terms_and_condtn' : false,
          'risk_warning_notice' : false,
          'read_privacy_policy' : false,
          'wont_provide_advice_in_trading' : false,
          'TTCA_agreement': '',
          'limit_group': '',
          'cfd_provider_name': '',
          'account_group': '',
          'organization': '',
          'supervisor_set': '',
          'operator_set': '',
          'discretionary_set': '',
          'account_active': '',
          'user_active': 'Y',
          'exchange_group': this.config('app.name'),
          'user_can_impersonate': 0,
          'user_can_be_impersonated': 0,
          'access_type': 0,
          'destination_group': 'DEFAULT',
          'read_only': 'N',
          'user_code': '',
          'upload_source': ''
        }
      }
    };
  },
  validators: {
    'formInput.firstname': function(value) {
      return Validator.value(value).required();
    },
    'formInput.lastname': function(value) {
      return Validator.value(value);
    },
    'formInput.account_number': function(value) {
      return Validator.value(value).required();
    },
    'formInput.dob': function(value) {
      if(['Natural Persons','FX'].indexOf(this.formInput.type)>=0)
        return Validator.value(value).regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    'formInput.phone_no': function(value) {
      return Validator.value(value);
    },
    'formInput.email': function(value) {
      return Validator.value(value).email().required();
    },
    'formInput.ni_number': function(value) {
      return Validator.value(value);
    },
    'formInput.address': function(value) {
      return Validator.value(value);
    },
    'formInput.city': function(value) {
      return Validator.value(value);
    },
    'formInput.state': function(value) {
      return Validator.value(value);
    },
    'formInput.country': function(value) {
      return Validator.value(value);
    },
    'formInput.zip': function(value) {
      return Validator.value(value);
    },
  },
  watch: {
    'formInput.account_number': function (input) {
      this.$refs.account_number.inputValue = input;
      this.getCustomer(input);
    },
    'formInput.client_group_name': function (input) {
      this.$refs.client_group_name.inputValue = input;
      this.getClientGroup(input);
    },
    'formInput.agent_account': function (input) {
      this.$refs.agent_account.inputValue = input;
      this.getAgentAccount(input);
    },
    'formInput.id': function(){
      if(this.formInput.action == 'delete' || this.formInput.action == 'approve' ) this.addCustomer();
    },
  },
  methods: {
    addCustomer: function(){
      (this.formInput.action!='delete'?this.$validate():Promise.resolve(true))
          .then(async (success) => {
            if (success) {
              const {response} = await this.call_axios('add_customer', 'post', this.formInput);
              this.forceRerender(response);
            }
          });
    },
    async getCustomer(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['account_number'] = input;
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.customers = response.data.result;

    },
    setCustomerInfo (group) {
      //Object.assign(this.formInput, group);
      this.formInput.account_number = group.account_number;
      //this.formInput.client_name = (typeof group == "object") ? group.firstname+' '+group.lastname : "" ;
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    customerFormattedDisplay (result) {
      return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    async getClientGroup(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['client_group_name'] = input;
      let uri = 'client_group_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.clinetGroups = response.data.result;

    },
    setClientGroupInfo (group) {
      Object.assign(this.formInput, group);
      //this.formInput.client_group_name = group.clinet_group_name;
      //this.formInput.client_group_id = group.clinet_group_id;
      //this.formInput.client_name = (typeof group == "object") ? group.firstname+' '+group.lastname : "" ;
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    clientGroupFormattedDisplay (result) {
      return result.client_group_name;
    },
    async getAgentAccount(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['ib_account'] = true;
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.agentAccounts = response.data.result;

    },
    setAgentAccountInfo (group) {
      //Object.assign(this.formInput, group);
      this.formInput.agent_account = group.account_number;
      //this.formInput.client_name = (typeof group == "object") ? group.firstname+' '+group.lastname : "" ;
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    agentAccountFormattedDisplay (result) {
      return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    async getClientCategories() {
      let uri = 'client_categories';
      const {response} = await this.call_axios(uri);
      this.client_categories = response.data.result;

    },
  },
  mounted(){

  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
    this.getClientCategories();
  }
};
</script>

<style lang="scss" scoped>
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
</style>